import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

import { Checkbox, FormControlLabel } from '@material-ui/core';
import { Paper, Button } from '../../Common/Components';
import COLOURS from '../../../constants/colour';

interface MerchantLoginEmailProps {
  onNext: (email: string) => void;
  rememberMe: boolean;
  setRememberMe: (value: boolean) => void;
  onForgotPassword: () => void;
  error?: string;
  clearErrors: () => void;
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'grid',
  },
  inputWrapper: {
    width: '100%',
    marginBottom: '20px',
  },
  input: {
    color: theme.palette.grey[600],
    borderColor: theme.palette.grey[600],
    borderWidth: '1px',

    '& input:-internal-autofill-selected,input:-webkit-autofill': {
      boxShadow: `0 0 0px 50px ${theme.palette.background.paper} inset`,
    },

    '&:hover + fieldset': {
      borderColor: theme.palette.grey[600],
    },
  },
  inputLabel: {
    color: theme.palette.grey[600],
  },
  header: {
    display: 'grid',
    gridGap: '16px',
    marginBottom: '40px',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  forgotButton: {
    color: COLOURS.Dark,
    backgroundColor: 'transparent',
    padding: 0,
    minWidth: 'auto',
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
  },
}));

const MerchantLoginEmailView: React.FC<MerchantLoginEmailProps> = ({
  onNext,
  rememberMe,
  setRememberMe,
  onForgotPassword,
  error,
  clearErrors,
}) => {
  const classes = useStyles();
  const [email, setEmail] = useState('');

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onNext(email);
  };

  const onEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    clearErrors();
    setEmail(e.target.value);
  };

  return (
    <Paper>
      <div className={classes.header}>
        <Typography variant="h1" color="primary">
          Enter the email for your merchant account
        </Typography>
      </div>

      <form onSubmit={onSubmit}>
        <TextField
          id="email"
          label="Enter Email"
          name="email"
          type="email"
          variant="outlined"
          autoComplete="email"
          className={classes.inputWrapper}
          value={email}
          focused={false}
          onChange={onEmailChange}
          InputProps={{ className: classes.input }}
          InputLabelProps={{ className: classes.inputLabel }}
          error={!!error}
          helperText={error}
        />

        <div className={classes.flexRow}>
          <Typography>
            Don&apos;t have an account? You need to be registered to get a Merchant Terminal.{' '}
            <a
              href="/signup"
              className={classes.link}
            >
              Click here to register.
            </a>
          </Typography>
        </div>

        <div className={classes.flexRow}>
          <FormControlLabel
            control={
              <Checkbox
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                name="rememberMe"
                color="primary"
                inputProps={{ 'aria-label': 'Checkbox Remember Me' }}
              />
            }
            label="Remember Me"
          />

          <Button className={classes.forgotButton} onClick={onForgotPassword} type="button">
            Forgot?
          </Button>
        </div>

        <Button className="wide" type="submit">
          Next
        </Button>
      </form>
    </Paper>
  );
};

export default MerchantLoginEmailView;
